<label class="form-label">{{ label }}</label>
<div class="row">
  <div class="col">
    <select class="form-select" [(ngModel)]="style" [ngModelOptions]="{standalone: true}" (ngModelChange)="onChange()">
      @for (style of styles; track style) {
        <option [ngValue]="style.value">{{ style.label }}</option>
      }
    </select>
  </div>
  @if (hasBorder()) {
    <div class="col-auto d-flex align-items-center">
      <img src="/images/misc/line-thickness.svg" alt="line thickness" height="24">
      <input class="ms-1 form-control form-width" [(ngModel)]="width" [ngModelOptions]="{standalone: true}" (ngModelChange)="onChange()" (blur)="checkWidth()"
        type="number" min="1"
        step="1">
      <span class="ms-1 fw-bold">px</span>
    </div>
  }
  <div class="col-auto d-flex align-items-center">
    <img src="/images/misc/rounded-rectangle.svg" alt="rounded rectangle" height="24">
    <input class="ms-1 form-control form-width" [(ngModel)]="radius" [ngModelOptions]="{standalone: true}" (ngModelChange)="onChange()" (blur)="checkRadius()"
      type="number" min="0"
      step="1">
    <span class="ms-1 fw-bold">px</span>
  </div>
  @if (hasBorder()) {
    <div class="col-auto">
      <input class="form-control form-control-color" [(ngModel)]="color" [ngModelOptions]="{standalone: true}" (ngModelChange)="onChange()" type="color">
    </div>
  }
</div>
